import posthog from 'posthog-js';
import { env } from '@/env';
import { enrichWithScreen } from '@/lib/posthog/enrich';

// Runs once, before hydration (Next.js client instrumentation). posthog.init here
// installs global window.onerror / onunhandledrejection handlers, so it captures
// above-React crashes (e.g. the org-switch "Application error") that never reach a
// React error boundary.
//
// Scope: error tracking + session replay (CL-319) + passive/consumption product
// analytics (CL-321) — SPA pageviews + dwell/scroll, with a `before_send` hook that
// tags every event with a normalised `screen`. Autocapture stays OFF; product
// events are explicit (see lib/posthog/events.ts). On for all deploys (NODE_ENV is
// 'production' on every Vercel build); off in local `next dev` unless you opt in
// with NEXT_PUBLIC_POSTHOG_DEBUG=true, which also turns on verbose SDK logging.
const isDebug = env.NEXT_PUBLIC_POSTHOG_DEBUG === 'true';

if (env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN && (env.NODE_ENV === 'production' || isDebug)) {
  posthog.init(env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN, {
    api_host: '/api/relay', // first-party reverse proxy (see next.config.mjs rewrites)
    ui_host: env.NEXT_PUBLIC_POSTHOG_HOST, // https://eu.posthog.com — for "open in PostHog" links
    defaults: '2025-11-30',
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false, // keep console noise out of error tracking
    },
    capture_pageview: 'history_change', // auto SPA pageviews on App Router navigations
    capture_pageleave: 'if_capture_pageview', // dwell + scroll depth, pairs with pageview
    autocapture: false, // explicit events only — keeps volume (and cost) down
    before_send: enrichWithScreen, // tag every event with `screen` + ids + appVersion/environment
    disable_session_recording: false,
    session_recording: { maskAllInputs: false }, // no PII worth masking; maximise replay readability
    loaded: isDebug ? (ph) => ph.debug() : undefined,
  });
}
